import rawCommonAdapterNameData from "../../../../resources/generated/components.json";
import type { componentID, Component, modeValues } from "../component-service";
/**
 * Enum representing the keys used in a Common Name Mapping object.
 */
export enum CommonAdapterNameKeys {
    COMMONNAME = "Common Name",
    IL = "IL",
    CDC = "CDC",
    DUPLICATE = "Duplicate Adapter" // This is added because CosmosDBReader is used in FD but not in Wizard, this can't be removed from sheets but to be removed from in wizard.
}

/**
 * Type representing all valid IDs(which are common name) present in adapter mapping.
 */
export type commonAdapterId = keyof typeof rawCommonAdapterNameData;

/**
 * Type representing Adapter Mapping Data.
 */
export interface commonAdapterData {
    [CommonAdapterNameKeys.COMMONNAME]: keyof typeof rawCommonAdapterNameData;
    [CommonAdapterNameKeys.IL]: componentID;
    [CommonAdapterNameKeys.CDC]: componentID;
    [CommonAdapterNameKeys.DUPLICATE]?: componentID;
}

/**
 * Type for Adapter Mapping Service.
 */
export interface CommonAdapterNameServiceType {
    getCommonNames: () => Array<commonAdapterId>;
    getComponentName: (commonName: componentID, appType: modeValues) => componentID;
    clubAdapters: (adapterList: Record<componentID, Component>) => void;
    getILComponentName: (commonName: string) => componentID;
    getCDCComponentName: (commonName: string) => componentID;
}
